import { Mail, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSeo, pageSeo, PAGES, clinicSchema, graph, crumbs } from "@/lib/seo";
import { telHref } from "@/lib/contact";
import { PageHero } from "@/components/common/SectionHeading";
import { CallButton, WhatsAppButton } from "@/components/common/ContactButtons";
import { MapEmbed } from "@/components/common/MapEmbed";
import { ClinicDetails } from "@/components/home/VisitClinic";
import { CallbackForm } from "@/components/common/CallbackForm";

export default function Contact() {
  const { settings } = useSite();
  useSeo({ ...pageSeo("/contact"), jsonLd: graph(clinicSchema(settings), crumbs(["Contact", "/contact"])) });
  return (
    <>
      <PageHero eyebrow="Contact" title={PAGES["/contact"].h1} intro={PAGES["/contact"].intro}>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <CallButton testid="contact-call-btn" label={`Call ${settings.phone_display}`} />
          <WhatsAppButton testid="contact-whatsapp-btn" />
        </div>
      </PageHero>
      <div className="container-x grid gap-12 py-14 md:py-20 lg:grid-cols-2 lg:gap-16">
        <div className="space-y-10">
          <ClinicDetails testid="contact-clinic-details" />
          <ul className="space-y-3 text-base">
            <li><a href={telHref(settings)} className="text-link" data-testid="contact-phone-link"><Phone className="h-4 w-4" aria-hidden="true" />{settings.phone_display}</a></li>
            <li><a href={`mailto:${settings.email}`} className="text-link break-all" data-testid="contact-email-link"><Mail className="h-4 w-4" aria-hidden="true" />{settings.email}</a></li>
          </ul>
          <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-skyTint via-white to-brand-greenTint p-6 shadow-[0_30px_60px_-40px_rgba(1,78,150,0.5)] ring-1 ring-brand-sky/20 sm:p-8" aria-labelledby="callback-heading">
            <h2 id="callback-heading" className="font-heading text-2xl font-bold text-brand-ink">Request a callback</h2>
            <p className="mb-6 mt-1 text-base text-slate-600">Leave your number and we'll call you back.</p>
            <CallbackForm />
          </section>
        </div>
        <MapEmbed className="h-80 lg:h-full lg:min-h-[36rem]" />
      </div>
    </>
  );
}
